import Avatar from "@mui/material/Avatar";
import { PagePermissions } from "./roles";
import { iUser } from "../interfaces/Auth/iUser";
import orgIcon from "../layout/Drawer/icons/orgIcon.svg"
import rolesIcon from "../layout/Drawer/icons/rolesIcon.svg"
import plansIcon from "../layout/Drawer/icons/plansIcon.svg"
import subsIcon from "../layout/Drawer/icons/subsIcon.svg"
import usersIcon from "../layout/Drawer/icons/usersIcon.svg"
import reportsIcon from "../layout/Drawer/icons/reportsIcon.svg"
import profileIcon from "../layout/Drawer/icons/profileIcon.svg"
import resourcesIcon from "../layout/Drawer/icons/resourcesIcon.svg"

interface ModalMenuType {
  label: string;
  route: string;
  icon: any;
  permission: PagePermissions | PagePermissions[] | null;
}

export const getModalMenu = (user: iUser): ModalMenuType[] => {
  return [
    {
      label: "Organizaciones",
      route: "organizations",
      icon: orgIcon,
      permission: "view:organization",
    },
    {
      label: "Organización",
      route: `organizations/${user.id_organizacion}`,
      icon: orgIcon,
      permission: "view:ownOrganization",
    },
    {
      label: "Roles",
      route: "roles",
      icon: rolesIcon,
      permission: "view:roles",
    },
    {
      label: "Roles",
      route: `roles/${user.id_organizacion}`,
      icon: rolesIcon,
      permission: "view:ownRoles",
    },
    {
      label: "Planes",
      route: "plans",
      icon: plansIcon,
      permission: "view:plans",
    },
    {
      label: "Planes",
      route: `plans/${user.id_organizacion}`,
      icon: plansIcon,
      permission: "view:ownPlans",
    },
    {
      label: "Suscripciones",
      route: "suscriptions",
      icon: subsIcon,
      permission: "view:suscriptions",
    },
    {
      label: "Suscripciones",
      route: `suscriptions/${user.id_organizacion}`,
      icon: subsIcon,
      permission: "view:ownSuscriptions",
    },
    {
      label: "Usuarios",
      route: "users",
      icon: usersIcon,
      permission: "view:users",
    },
    {
      label: "Usuarios",
      route: `users/${user.id_organizacion}`,
      icon: usersIcon,
      permission: "view:ownUsers",
    },
    {
      label: "Reportes & Auditorías",
      route: "auditorias/eventos/organizacion",
      icon: reportsIcon,
      permission: "view:reports",
    },
    {
      label: "Reportes & Auditorías",
      route: `auditorias/eventos/organizacion/${user.id_organizacion}`,
      icon: reportsIcon,
      permission: "view:ownReports",
    },
    {
      label: "Gestor de Usuarios",
      route: "allusers",
      icon: usersIcon,
      permission: "view:users",
    },
    {
      label: "Perfil",
      route: "userprofile",
      icon: profileIcon,
      permission: null,
    },
    {
      label: "Mis recursos de aprendizaje",
      route: "myprojects",
      icon: resourcesIcon,
      permission: null,
    },
  ];
};
